import { getOrderDetails, getOrderId } from '@app/ducks';
import { getIsOrderClosed } from '@app/logic/Orders';
import { compiledPaths } from '@app/paths';
import { Navigation } from '@typings';
import React from 'react';
import { useSelector } from 'react-redux';

export const useSelectionNavigationItems = (items: Navigation.UserMenuItem[]) => {
  const orderDetails = useSelector(getOrderDetails);
  const isOrderClosed = getIsOrderClosed(orderDetails.order);
  const selectionId = useSelector(getOrderId);

  const mapUserNavigationItemToNavigationItem = React.useCallback(
    (item: Navigation.UserMenuItem): Navigation.Item => {
      // eslint-disable-next-line default-case
      switch (item.type) {
        case 'folder': {
          return {
            children: (item.children ?? []).map(mapUserNavigationItemToNavigationItem),
            label: item.label,
            type: item.type,
          };
        }
        case 'link': {
          return {
            label: item.label,
            openNewTab: item.openNewTab,
            type: item.type,
            url: item.url,
          };
        }
        case 'page': {
          const targetUrl =
            isOrderClosed ?
              compiledPaths.PAGE_ROOT({ pageSlug: item.url })
            : compiledPaths.PAGE_ORDER({ id: selectionId, pageSlug: item.url });

          return {
            children: (item.children ?? []).map(mapUserNavigationItemToNavigationItem),
            label: item.label,
            openNewTab: item.openNewTab,
            type: item.type,
            url: targetUrl,
          };
        }
      }
    },
    [isOrderClosed, selectionId],
  );

  return React.useMemo(() => items.map(mapUserNavigationItemToNavigationItem), [items, mapUserNavigationItemToNavigationItem]);
};
